// Check if the filter is REALLY empty (null/empty string/empty array/etc...)
export const filterHasValue = (values) => (filter) => {
  const value = values?.[filter.id];

  if (!value) {
    return false;
  }

  if (Array.isArray(value) && value.length === 0) {
    return false;
  }

  if (typeof value === 'string' && value.trim() === '') {
    return false;
  }

  return true;
};
